import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CategorySiteSearchBase from './category-site-autocomplete';
import PostcodeAutocompleteBase from './postcode-autocomplete';
import styled, { css } from 'styled-components';
import logo from './logo';
import { HeaderLink } from '../header';
import { Button } from '../buttons';
const STATE_CLOSED = 'closed';
const STATE_SEARCH = 'search';
const STATE_MENU = 'menu';

const GA_CATEGORY = 'Header Menu';

const PostcodeAutocomplete = PostcodeAutocompleteBase.extend`
  & {
    display: block;
    margin-bottom: 10px;
    width: 100%;
    position: relative;

    &__container {
      width: 100%;
    }

    &__input {
      width: 100%;
      margin: 0;
      borde-radius: 4px !important;
    }

    &__suggestions-container {
      position: relative !important;
      top: initial;
      background: #fff;
      width: 100% !important;
      z-index: 2;
      top: initial !important;
      left: 0 !important;
    }
  }
`;

const CategorySiteSearch = CategorySiteSearchBase.extend`
  & {
    display: block;
    margin-bottom: 10px;
    width: 100%;
    position: relative;

    &__container {
      width: 100%;
    }

    &__input {
      width: 100%;
      margin: 0;
      borde-radius: 4px !important;
    }

    &__suggestions-container {
      position: relative !important;
      top: initial;
      background: #fff;
      width: 100% !important;
      z-index: 2;
      top: initial !important;
      left: 0 !important;
    }
  }
`;

export default class MobileHeader extends Component {
  static propTypes = {
    siteText: PropTypes.string,
    postcodeText: PropTypes.string,
    expanded: PropTypes.bool,
    onSearchSubmit: PropTypes.func,
    siteSource: PropTypes.string,
    setHeaderSite: PropTypes.func,
    setHeaderPostcode: PropTypes.func,
    expandHeaderSearch: PropTypes.func,
    fetchUserInfo: PropTypes.func,
    search: PropTypes.func,
    loginStatus: PropTypes.string,
    loginInfo: PropTypes.object
  };

  state = {
    isOpen: STATE_CLOSED
  };

  openMenu = () => {
    this.setState({ isOpen: STATE_MENU });
  };

  openSearch = () => {
    this.setState({ isOpen: STATE_SEARCH });
  };

  close = () => {
    this.setState({ isOpen: STATE_CLOSED });
  };

  render() {
    const { isOpen } = this.state;
    const {
      siteText,
      setHeaderSite,
      postcodeText,
      setHeaderPostcode,
      onSearchSubmit,
      siteSource
    } = this.props;
    return (
      <div>
        <div style={{ float: 'left', padding: '4px 10px' }}>
          <Logo />
          <MobileTagLine>Australia&apos;s #1 site to hire tradespeople</MobileTagLine>
        </div>
        <div style={{ float: 'right' }}>
          <MobileIcon
            className="hui-icon-search"
            selected={isOpen === STATE_SEARCH}
            onClick={isOpen === STATE_SEARCH ? this.close : this.openSearch}
          />
          <MobileIcon
            className="hui-icon-hamburger"
            selected={isOpen === STATE_MENU}
            onClick={isOpen === STATE_MENU ? this.close : this.openMenu}
          />
        </div>
        <div>
          <MobileDropdown open={isOpen === STATE_MENU}>
            <MobileNav>
              <li>
                <HeaderLink
                  href="/get_quotes_simple"
                  title="Get Quotes"
                  data-ga-category={GA_CATEGORY}
                  data-ga-action={`${GA_CATEGORY} - Clicked Get Quotes - Mobile`}
                  data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                >
                  Get Quotes
                </HeaderLink>
              </li>
              <li>
                <HeaderLink
                  href="http://hipag.es/1YGeRMs"
                  title="Download the App"
                  data-ga-category={GA_CATEGORY}
                  data-ga-action={`${GA_CATEGORY} - Clicked Download the App - Mobile`}
                  data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                >
                  Download the App
                </HeaderLink>
              </li>
              <li>
                <HeaderLink
                  href="/advertise"
                  title="List Your Business"
                  data-ga-category={GA_CATEGORY}
                  data-ga-action={`${GA_CATEGORY} - Clicked List Your Business - Mobile`}
                  data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                >
                  List Your Business
                </HeaderLink>
              </li>
              <li>
                <HeaderLink
                  href="/find"
                  title="Directory"
                  data-ga-category={GA_CATEGORY}
                  data-ga-action={`${GA_CATEGORY} - Clicked Directory - Mobile`}
                  data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                >
                  Directory
                </HeaderLink>
              </li>
              <li>
                <HeaderLink
                  href="/articles"
                  title="Articles"
                  data-ga-category={GA_CATEGORY}
                  data-ga-action={`${GA_CATEGORY} - Clicked Articles - Mobile`}
                  data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                >
                  Articles
                </HeaderLink>
              </li>
              <li>
                <HeaderLink
                  href="/photos"
                  title="Photos"
                  data-ga-category={GA_CATEGORY}
                  data-ga-action={`${GA_CATEGORY} - Clicked Browse Photos - Mobile`}
                  data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                >
                  Photos
                </HeaderLink>
              </li>
              <li>
                <HeaderLink
                  href="/register"
                  title="Register"
                  data-ga-category={GA_CATEGORY}
                  data-ga-action={`${GA_CATEGORY} - Clicked Sign Up - Mobile`}
                  data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                >
                  Register
                </HeaderLink>
              </li>
              <li>
                <HeaderLink
                  href="/login"
                  title="Sign in"
                  data-ga-category={GA_CATEGORY}
                  data-ga-action={`${GA_CATEGORY} - Clicked Login - Mobile`}
                  data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                >
                  Sign in
                </HeaderLink>
              </li>
            </MobileNav>
          </MobileDropdown>
          <MobileDropdown open={isOpen === STATE_SEARCH}>
            <p className="hui-header__mobile-search-title">
              Over 80,000 trade businesses across 1,100+ service categories
            </p>
            <form onSubmit={onSearchSubmit}>
              <CategorySiteSearch
                theme="mobile-category-search"
                onChange={setHeaderSite}
                value={siteText}
                name="search_str"
              />
              <PostcodeAutocomplete
                classPrefix="mobile-postcode-search"
                onChange={setHeaderPostcode}
                value={postcodeText}
                name="search_zip"
              />
              <Button type="submit" primary block>
                Search
              </Button>
            </form>
          </MobileDropdown>
        </div>
      </div>
    );
  }
}

const MobileNav = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;
  li {
    color: #333;
    font-size: 14px;
    text-decoration: none;
    padding: 10px 0;
    display: block;
    border-bottom: 1px solid #ddd;
  }
`;

const MobileDropdown = styled.div`
  background-color: #eee;
  width: 100%;
  box-shadow: 0 6px 3px -3px rgba(0, 0, 0, 0.02);
  overflow: auto;
  zoom: 1;
  padding: 0 20px;
  transition: max-height 0.5s ease-in-out;
  max-height: ${props => (props.open ? 1000 : 0)}px;
`;

const MobileIcon = styled.div`
  padding: 21px 20px;
  font-size: 18px;
  color: #888;
  display: inline-block;
  ${props =>
    props.selected &&
    css`
      background-color: #eee;
    `};
`;

const Logo = styled.div`
  background: url(${logo}) no-repeat;
  width: 90px;
  height: 33px;
  background-size: contain;
  text-indent: -99999px;
  display: block;
`;

const MobileTagLine = styled.div`
  margin-top: 10px;
  color: #aaa;
  font-weight: 400;
  font-size: 11px;
  line-height: 0.5em;
  padding-bottom: 3px;
`;
